import { FC } from "react";
import { Box } from "@chakra-ui/react";

interface CaseDocumentProgressBarProps {
  /** 0–100; more is shown full */
  value: number;
  color?: string;
  h?: string;
}

const CaseDocumentProgressBar: FC<CaseDocumentProgressBarProps> = ({ value, color = "brand.primary", h = "6px" }) => (
  <Box h={h} bg="gray.100" borderRadius="full" overflow="hidden">
    <Box h="100%" w={`${Math.min(100, value)}%`} bg={color} borderRadius="full" transition="width 0.15s linear" />
  </Box>
);

export default CaseDocumentProgressBar;
